import React, { Component } from 'react';
import { Flex, Page } from './base/layout-components';
import Text from './base/Text';
import Oops from 'images/characters/oops.svg';
import { Link } from '@material-ui/core';
import * as ZendeskService from 'common/services/zendesk.service';

const DefaultErrorComponent = ({ componentName, height }) => (
  <Flex
    width='100%'
    height={height}
    items='center'
    justify='center'
    direction='column'
    padding='medium'
  >
    <img src={Oops} alt='Oops' />
    <Text pt='1rem' color='shark' size='medium'>
      {componentName
        ? `${componentName} is a no-show at the moment`
        : 'looks like we are having trouble displaying this content.'}
    </Text>
    <Text color='shark' size='medium'>
      Try refreshing your page. If that doesn't work{' '}
      <Link onClick={() => ZendeskService.openSupportRequest()}>
        contact support
      </Link>
    </Text>
  </Flex>
);

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {}

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    const { children, errComponent, componentName, isPage, height } =
      this.props;
    const _errComponent = errComponent || (
      <DefaultErrorComponent
        height={isPage ? '' : height || '100%'}
        componentName={componentName}
      />
    );

    return error ? (
      isPage ? (
        <Page>{_errComponent}</Page>
      ) : (
        _errComponent
      )
    ) : (
      children
    );
  }
}
